import { Configuration, LogLevel } from '@azure/msal-browser';

declare global {
  interface Window {
    config: {
      appid: string;
      tenantid: string;
      apibaseurl: string;
      redirectUri: string;
    };
  }
}

export const msalConfig: Configuration = {
  auth: {
    clientId: window.config.appid,
    authority: `https://login.microsoftonline.com/${window.config.tenantid}`,
    redirectUri: window.config.redirectUri,
    postLogoutRedirectUri: 'http://localhost:5173',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // or "sessionStorage"
    storeAuthStateInCookie: false, // set true for legacy browsers
  },
  system: {
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const loginRequest = {
  scopes: [
    'User.Read',
    'openid',
    'profile',
    `api://${window.config.appid}/user_impersonation`,
  ],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  scopes: ['User.Read'], // Graph-specific scopes
};

export const tokenRequest = {
  scopes: [`api://${window.config.appid}/user_impersonation`],
};
